module.exports = __webpack_public_path__ + "img/Planet.b75b9b62.svg";